import {Anchor, Text} from '@mantine/core';
import {I18n} from '@aws-amplify/core';
import {PlatformPropertyCard, PlatformPropertyCardEntryInput} from '@flexinet/ui-components';

import {PricingSourceBadge, ProductStatusBadge} from './Badges';
import {PricingSource, Product, ProductStatus} from '../types';

// The API only accepts https:// links, but the link is still checked here:
// an href is the one place a stored string becomes something clickable.
const EulaLink = ({url}: { url: string }) =>
    url.startsWith('https://')
        ? <Anchor href={url} target='_blank' rel='noopener noreferrer' size='sm'>{url}</Anchor>
        : <Text size='sm'>{url}</Text>;

export const Profile = ({record}: { record: Product }) => {

    const properties: PlatformPropertyCardEntryInput[] = [
        {label: I18n.get('Name'), value: record.name, span: 12},
        {label: I18n.get('Summary'), value: record.summary, span: 12},
        {label: I18n.get('Description'), value: record.description, span: 12},
        {
            label: I18n.get('EULA link'),
            value: record.eulaUrl,
            formatter: (url: string) => <EulaLink url={url}/>,
            span: 12,
        },
        {label: I18n.get('Support contact'), value: record.supportContact, span: 12},
        {
            label: I18n.get('Status'),
            value: record.status,
            formatter: (status: ProductStatus) => <ProductStatusBadge status={status}/>,
            span: 12,
        },
        {
            label: I18n.get('Pricing source'),
            value: record.pricingSource,
            formatter: (source: PricingSource) => <PricingSourceBadge source={source}/>,
            span: 12,
        },
        {label: I18n.get('Version'), value: record.version, span: 12},
        {label: I18n.get('Created'), value: record.created, formatter: 'timestamp', span: 12},
        {label: I18n.get('Last updated'), value: record.updated, formatter: 'timestamp', span: 12},
    ];

    // emptyAs 'dash': a missing value reads as an em dash, never as blank.
    return <PlatformPropertyCard properties={properties} emptyAs='dash'/>;
};
